const UNITS = {
  IN_MIN: "in/min",
  IN: "in",
  CM: "cm",
  MM: "mm",
  CM_MIN: "cm/min",
  MM_MIN: "mm/min",
  LB: "lb",
  KG: "kg",
  KJ_IN: "kJ/in",
  KJ_CM: "kJ/cm",
  KJ_MM: "kJ/mm",
};

// Global unit enum to replace hardcoded strings
export const GlobalUnitEnum = {
  IMPERIAL: "imperial",
  METRIC: "metric",
};

// Decimal points enum for non-live version
export const DecimalPointsEnum = {
  VOLTS: 1,
  CURRENT: 0,
  WIRE_SPEED: 0,
  TRAVEL_SPEED: 1,
  TRAVEL_SPEED_METRIC: 0,
  OSCILLATION_WIDTH: 3,
  OSCILLATION_WIDTH_METRIC: 1,
  DISTANCE: 0,
  FREQUENCY: 0,
  HEAT: 1,
  HEAT_METRIC: 2,
  TRUE_ENERGY: 1,
  TRUE_ENERGY_METRIC: 2,
  HEAD_ANGLE: 1,
  ARC_IMPEDANCE: 2,
  TARGET: 0,
  HORIZONTAL_BIAS: 2,
  TOTAL_WIRE_CONSUMED: 2,
  WIRE_DIAMETER: 3,
  DEFAULT: 2,
};

export const reportColumnEnums = {
  ArcCurrent: "ArcCurrent",
  ArcVolts: "ArcVolts",
  TravelSpeed: "Travel Speed",
  TrueEnergy: "True Energy",
  Heat: "Heat",
  WireSpeed: "Wire Speed",
  OscillationWidth: "Oscillation Width",
  Frequency: "Frequency",
  Target: "Target",
  HorizontalBias: "Horizontal Bias",
  TotalWireConsumed: "Total Wire Consumed",
  BandDiameter: "Band Diameter",
  WireDiameter: "Wire Diameter",
  LoggingDistance: "Logging Distance",
  Distance: "Distance",
};

export const convertValue = (
  value,
  toUnits = "",
  isFromTLogScreen = false,
  decimalPoints = null
) => {
  console.log(value, toUnits, isFromTLogScreen, decimalPoints, "value");

  let isColorIncluded = value?.toString()?.includes("-color");
  value = value?.toString()?.includes("-color")
    ? value?.toString().replace("-color", "")
    : value;

  const parsedValue = parseFloat(value);
  let convertedValue = value;

  if (!isNaN(parsedValue)) {
    switch (toUnits) {
      // case UNITS.IN_MIN:
      //   convertedValue
      //   break;
      // case UNITS.IN:
      //   convertedValue = parsedValue / 2.54;
      //   break;
      case UNITS.CM:
        convertedValue = parsedValue * 2.54;
        break;
      case UNITS.MM:
        convertedValue = parsedValue * 25.4;
        break;
      case UNITS.CM_MIN:
        convertedValue = parsedValue * 2.54;
        break;
      case UNITS.MM_MIN:
        convertedValue = parsedValue * 25.4;
        break;
      case UNITS.LB:
        convertedValue = parsedValue * 2.205;
        break;
      case UNITS.KG:
        convertedValue = parsedValue / 2.205;
        break;
      // case UNITS.KJ_IN:
      //   convertedValue = parsedValue * 2.54;
      //   break;
      case UNITS.KJ_CM:
        convertedValue = parsedValue / 2.54;
        break;
      case UNITS.KJ_MM:
        convertedValue = parsedValue / 25.4;
        break;
      default:
        break;
    }

    if (!Number.isInteger(convertedValue)) {
      convertedValue = isFromTLogScreen
        ? convertedValue
        : parseFloat(convertedValue).toFixed(
            decimalPoints == 0 || decimalPoints ? decimalPoints : 2
          );
    }

    return `${convertedValue}${isColorIncluded ? "-color" : ""}`;
  }

  return value;
};

export const MEASUREMENT_KEYS = {
  AMPS: "AMPS",
  FREQUENCY: "FREQUENCY",
  TRAVEL_SPEED: "TRAVEL_SPEED",
  WIRE_SPEED: "WIRE_SPEED",

  VOLTS: "VOLTS",
  DISTANCE: "DISTANCE",

  HEAT: "HEAT",
  CALCULATED_HEAT: "CALCULATED_HEAT",
  OSCILLATE_WIDTH: "OSCILLATE_WIDTH",

  TRUE_ENERGY: "TRUE_ENERGY",
  TARGET: "TARGET",
  HORIZONTAL_BIAS: "HORIZONTAL_BIAS",
  TOTAL_WIRE_CONSUMED: "TOTAL_WIRE_CONSUMED",
  WIRE_DIAMETER: "WIRE_DIAMETER",
};

export const getDecimalPoint = (
  measurementKey,
  globalUnit = GlobalUnitEnum.IMPERIAL
) => {
  const isMetric = globalUnit === GlobalUnitEnum.METRIC;

  switch (measurementKey) {
    case MEASUREMENT_KEYS.VOLTS:
      return DecimalPointsEnum.VOLTS;
    case MEASUREMENT_KEYS.AMPS:
    case MEASUREMENT_KEYS.CURRENT_A:
      return DecimalPointsEnum.CURRENT;
    case MEASUREMENT_KEYS.WIRE_SPEED:
      return DecimalPointsEnum.WIRE_SPEED;
    case MEASUREMENT_KEYS.TRAVEL_SPEED:
      return isMetric
        ? DecimalPointsEnum.TRAVEL_SPEED_METRIC
        : DecimalPointsEnum.TRAVEL_SPEED;
    case MEASUREMENT_KEYS.OSCILLATE_WIDTH:
      return isMetric
        ? DecimalPointsEnum.OSCILLATION_WIDTH_METRIC
        : DecimalPointsEnum.OSCILLATION_WIDTH;
    case MEASUREMENT_KEYS.DISTANCE:
      return DecimalPointsEnum.DISTANCE;
    case MEASUREMENT_KEYS.FREQUENCY:
      return DecimalPointsEnum.FREQUENCY;
    case MEASUREMENT_KEYS.HEAT:
    case MEASUREMENT_KEYS.CALCULATED_HEAT:
      return isMetric ? DecimalPointsEnum.HEAT_METRIC : DecimalPointsEnum.HEAT;
    case MEASUREMENT_KEYS.TRUE_ENERGY:
      return isMetric
        ? DecimalPointsEnum.TRUE_ENERGY_METRIC
        : DecimalPointsEnum.TRUE_ENERGY;
    case MEASUREMENT_KEYS.HEAD_ANGLE:
      return DecimalPointsEnum.HEAD_ANGLE;
    case MEASUREMENT_KEYS.ARC_IMPEDANCE:
      return DecimalPointsEnum.ARC_IMPEDANCE;
    case MEASUREMENT_KEYS.TARGET:
      return DecimalPointsEnum.TARGET;
    case MEASUREMENT_KEYS.HORIZONTAL_BIAS:
      return DecimalPointsEnum.HORIZONTAL_BIAS;
    case MEASUREMENT_KEYS.TOTAL_WIRE_CONSUMED:
      return DecimalPointsEnum.TOTAL_WIRE_CONSUMED;
    case MEASUREMENT_KEYS.WIRE_DIAMETER:
      return DecimalPointsEnum.WIRE_DIAMETER;
    default:
      return DecimalPointsEnum.DEFAULT;
  }
};
